import { useEffect, useState } from "react";
import { Tratamiento } from "../../models/riesgo/Tratamiento";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useForm } from "react-hook-form";
import { InputComponent } from "../../components/InputComponent";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import { Monitoreo } from "./Monitoreo";
import { Dialog } from "primereact/dialog";
import { Criterios } from "./Criterios";
import { Consecuencias } from "./Consecuencias";
import { ProgressSpinner } from "primereact/progressspinner";

export const Evaluacion = ({ riesgo, id, toast, permss, generic, seccion, nextPrev, handleNext, siguienteTab, setSiguienteTab, setLoadingSave, setLoadingNext, funcionalidades }) => {

    const omodel = new Tratamiento();
    const defaultValues = generic.default(omodel.model, null);
    const [registers] = useState(null);
    const [tipo, setTipo] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [dialogCriterio, setDialogCriterio] = useState(false);
    const [titulo, setTitulo] = useState(null);
    const [estilos, setEstilos] = useState(null);
    const [valor, setValor] = useState(null);
    const [dialogConsecuencia, setDialogConsecuencia] = useState(false);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues });
    const matrizSrv = new MonitoreoService();
    const { inDrop } = InputComponent({ registers: registers, omodel, generic, errors, control, permss, id: getValues('id') });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        consultar();
    }, []);

    const consultar = () => {
        setLoading(true);
        const ids = id ?? getValues('id') ?? 0;
        matrizSrv.consultar(`${ids}/${riesgo?.id}/${seccion}`, 'matriz-riesgo-detalle/consulta').then(res => {
            setCatalogos(res.data?.catalogos);
            const _riesgo = res.data?.info;
            let _values = null;
            if (_riesgo && Object.keys(_riesgo).length > 0) {
                _values = generic.renewValues(_riesgo, omodel.model);
                reset(_values);
            }
            const vals = iniciar(_values, res.data?.catalogos?.color);
            if (_values) {
                vals.control_efectivo = _values?.control_efectivo;
                calcular(null, null, vals, res.data?.catalogos);
            }
        }).finally(() => setLoading(false));
    }

    const iniciar = (_values = null, ccolor = null) => {
        const mdl = _values ?? omodel.model;
        const vals = {};
        const style = {};
        const _vals = ['control_efectivo', 'probabilidad', 'probabilidad_p1', 'impacto', 'consecuencias', 'nivel_riesgo_residual', 'alrt_tolerancia_riesgo', 'alrt_tolerancia_riesgo_residual'];
        Object.keys(mdl).forEach(function (key) {
            if (_vals.includes(key)) {
                vals[key] = mdl[key] ?? '';
                style[key] = mdl[key] ? colores(mdl[key], {}, ccolor) : {};
            } else if (key === 'evaluacion_riesgo_ranqueo') {
                vals[key] = mdl[key]?.nombre ?? '';
                style[key] = mdl[key]?.nombre ? colores(mdl[key]?.orden, {}, ccolor) : {};
            } else if (['control_ayuda', 'trmto_riesgo'].includes(key)) {
                vals[key] = mdl[key]?.nombre ?? '';
            }
        });
        setEstilos(style);
        setValor(vals);
        return vals;
    }

    const seleccion = (info, listado) => {
        const _lista = catalogos;
        _lista[tipo] = listado;
        setCatalogos(_lista);
    }

    const actualizarCatalogo = (tipo, nuevoListado) => {
        const adaptado = nuevoListado.map(item => ({ cat_id: item.cat_id, nombre: item.nivel ?? '', orden: item.orden }));
        setCatalogos(prev => ({ ...prev, [tipo]: adaptado }));
    };

    const onSubmit = (data) => {
        const ids = id ?? getValues('id') ?? 0;
        data.idp = riesgo?.id;
        data.seccion = seccion;
        data.id = ids;
        setLoadingSave(true);
        setLoadingNext(true);
        matrizSrv.editar(data, 'matriz-riesgo-detalle/editar').then(res => {
            generic.funcSuccess(res, toast);
            if (siguienteTab) {
                setSiguienteTab(false);
                handleNext();
            }
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => {
            setLoadingSave(false);
            setLoadingNext(false);
        });
    }

    const mostrarConsecuencia = (tipo, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setDialogConsecuencia(true);
        setTipo(tipo);
    }

    const colores = (val, nivel = {}, ccolor = null) => {
        const info = ccolor ?? catalogos?.color;
        const res = { fontSize: '1em', fontWeight: 'bold', display: 'grid', placeItems: 'center', textAlign: 'center' };
        for (let i = 0; i < info.length; i++) {
            const col = info[i];
            if (val > parseFloat(col.minimo) && val <= parseFloat(col.maximo)) {
                res.backgroundColor = '#' + col.color;
                res.color = '#' + col.tcolor;
                nivel.nivel = col.nombre;
            }
        }
        return res;
    }

    const onChange = (e, val) => {
        calcular(e, val, valor);
    }

    const calcular = (e = null, val = null, _valor = null, cats = null) => {
        const _catalogos = cats ?? catalogos;
        const ccolor = _catalogos?.color;
        const _value = e?.value;
        const vvalor = _value?.nombre;

        let probabilidad = _valor?.probabilidad;
        let consecuencias = _valor?.consecuencias;
        let nivel_riesgo_residual = _valor?.nivel_riesgo_residual;
        let alrt_tolerancia_riesgo_residual = _valor?.alrt_tolerancia_riesgo_residual;
        let evaluacion_riesgo_ranqueo = _valor?.evaluacion_riesgo_ranqueo;
        let ranStyle = null;
        if (val === 'control_ayuda' && _value) {
            probabilidad = _valor?.probabilidad_p1;
            consecuencias = _valor?.impacto;
            if (['CTR_AYUDA_PROBABILIDAD', 'CTR_AYUDA_PROBABILIDAD_CONSECUENCIA'].includes(_value.sigla)) {
                probabilidad = (_valor?.probabilidad_p1 + _valor.control_efectivo) / 2;
            }
            if (['CTR_AYUDA_CONSECUENCIA', 'CTR_AYUDA_PROBABILIDAD_CONSECUENCIA'].includes(_value.sigla)) {
                consecuencias = Math.round((_valor?.impacto + _valor.control_efectivo) / 2);
            }
            nivel_riesgo_residual = (probabilidad + consecuencias) / 2;
            alrt_tolerancia_riesgo_residual = nivel_riesgo_residual > _catalogos?.RES_TOLERANCIA ? 'ALERTA' : 'NO ALERTA';
        } else if (val === 'evaluacion_riesgo_ranqueo' && _value) {
            evaluacion_riesgo_ranqueo = _value?.nombre;
            ranStyle = colores(_value?.orden, {}, ccolor);
        }

        const proStyle = colores(probabilidad, {}, ccolor);
        const conStyle = colores(consecuencias, {}, ccolor);
        const colorRiesgo = {};
        const _color = colores(nivel_riesgo_residual, colorRiesgo, ccolor);
        const rieStyle = _color
        const alrt_tolerancia_riesgo = colorRiesgo.nivel;
        const estilo_tolerancia_riesgo_residual = alrt_tolerancia_riesgo_residual === 'ALERTA' ? colores(5, {}, ccolor) : sstyle();
        const alrtStyle = _color;
        const impactos = _catalogos?.MTR_RIESGO_CONSECUENCIA;
        const _impacto = impactos?.find(x => x.orden === consecuencias);
        const descripcion = _impacto?.nombre;

        setEstilos((prevColor) => ({
            ...prevColor,
            probabilidad: proStyle,
            consecuencias: conStyle,
            nivel_riesgo_residual: rieStyle,
            alrt_tolerancia_riesgo: alrtStyle,
            alrt_tolerancia_riesgo_residual: estilo_tolerancia_riesgo_residual,
            ...(ranStyle !== null && { [val]: ranStyle }),
        }));
        setValor((prevValue) => ({
            ...prevValue,
            ...(val !== null && vvalor && { [val]: vvalor }),
            probabilidad,
            consecuencias,
            nivel_riesgo_residual,
            alrt_tolerancia_riesgo,
            alrt_tolerancia_riesgo_residual,
            evaluacion_riesgo_ranqueo,
            descripcion
        }));
    }

    const cclase = (col = 1) => {
        const class1 = `field border-1 border-solid border-gray-700 col-${col} m-0`;
        return class1;
    }

    const sstyle = () => {
        const style = { display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-word', padding: '0.5rem', };
        return style;
    }

    const criterios = (opc, ccampo) => {
        setTitulo(omodel?.model[ccampo]?.header);
        setTipo(opc);
        setDialogCriterio(true);
    }

    return (
        <>
            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', color: '#444', fontWeight: '500', fontSize: '1.2rem' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth={5} />
                    <span style={{ marginTop: '1rem' }}>Cargando información...</span>
                </div>
            ) : (
                <div className="formgrid grid">
                    <div className="field col-8">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="formgrid grid">
                                <div className="field col-12">
                                    {catalogos?.color !== undefined &&
                                        <div className="formgrid grid text-center font-bold text-sm">
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.control_efectivo?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.control_ayuda?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.probabilidad?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.consecuencias?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.nivel_riesgo_residual?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.alrt_tolerancia_riesgo_residual?.header}</div>
                                            <div className={cclase(2)} style={sstyle()}>{omodel?.model?.evaluacion_riesgo_ranqueo?.header}</div>
                                            <div className={cclase()} style={sstyle()}>{omodel?.model?.trmto_riesgo?.header}</div>

                                            <div className={cclase()} style={estilos?.control_efectivo}>{valor?.control_efectivo}</div>
                                            <div className={cclase(2)} style={sstyle()}>{valor?.control_ayuda}</div>
                                            <div className={cclase()} style={estilos?.probabilidad}>{valor?.probabilidad}</div>
                                            <div className={cclase()} style={estilos?.consecuencias}>{valor?.consecuencias}</div>
                                            <div className={cclase()} style={estilos?.nivel_riesgo_residual}>{valor?.nivel_riesgo_residual}</div>
                                            <div className={cclase()} style={estilos?.alrt_tolerancia_riesgo}>{valor?.alrt_tolerancia_riesgo}</div>
                                            <div className={cclase(2)} style={estilos?.alrt_tolerancia_riesgo_residual}>{valor?.alrt_tolerancia_riesgo_residual}</div>
                                            <div className={cclase(2)} style={estilos?.evaluacion_riesgo_ranqueo}>{valor?.evaluacion_riesgo_ranqueo}</div>
                                            <div className={cclase()} style={sstyle()}>{valor?.trmto_riesgo}</div>
                                        </div>
                                    }
                                </div>
                                <div className="field col-12" style={{ marginTop: '1rem' }}>
                                    <div style={{ border: '1px solid #ccc', borderRadius: '8px', padding: '1rem', backgroundColor: '#f9f9f9', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', lineHeight: '1.5', fontSize: '0.95rem' }}>
                                        <strong>{omodel?.model?.descripcion?.header}</strong>
                                        <p style={{ marginTop: '0.5rem', whiteSpace: 'pre-line', textAlign: 'justify' }}>{valor?.descripcion}</p>
                                    </div>
                                </div>
                                <Divider />
                                <div className="formgrid grid" style={{ width: '100%', alignItems: 'flex-end', padding: '6.5px' }}>
                                    {inDrop('control_ayuda', catalogos?.MTR_RIESGO_CONTROL_AYUDA, { lab: 'nombre', val: 'control_ayuda', chn: onChange }, 3)}
                                    <div className="field col-1" style={{ visibility: 'hidden' }}>
                                        {/* Espacio vacio para mantener la proporción */}
                                    </div>
                                    {inDrop('evaluacion_riesgo_ranqueo', catalogos?.MTR_RIESGO_RANQUEO, { lab: 'nombre', val: 'evaluacion_riesgo_ranqueo', chn: onChange }, 3)}
                                    <div className="field col-1">
                                        <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar"
                                            onClick={() => mostrarConsecuencia('MTR_RIESGO_RANQUEO', 'evaluacion_riesgo_ranqueo')} />
                                    </div>
                                    {inDrop('trmto_riesgo', catalogos?.MTR_RIESGO_TRATAMIENTO, { lab: 'nombre', val: 'trmto_riesgo', chn: onChange }, 3)}
                                    <div className="field col-1">
                                        <Button icon="pi pi-search-plus" rounded severity="info" type="button" tooltip="Consultar"
                                            onClick={() => criterios('MTR_RIESGO_TRATAMIENTO', 'trmto_riesgo')} />
                                    </div>
                                </div>
                            </div>

                            {nextPrev('ambos')}
                        </form>
                    </div >
                    <div className="col-4">
                        {catalogos?.MTR_RIESGO_MONITOREO_REVISION !== undefined && <Monitoreo generic={generic} permss={permss} toast={toast} riesgo={riesgo} id={id} catalogo={catalogos} funcionalidades={funcionalidades} />}
                    </div>
                </div >
            )}
            <Dialog visible={dialogCriterio} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => { setDialogCriterio(false); setTipo(null); }}
                style={{ maxWidth: '500px' }}>
                {tipo && <Criterios toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} seleccion={seleccion} seleccionar={false} listar="ambos" funcionalidades={funcionalidades} />}
            </Dialog>

            <Dialog visible={dialogConsecuencia} header={titulo} modal className="p-fluid dialog-personalizado" onHide={() => {
                setDialogConsecuencia(false);
            }}
                style={{ maxWidth: '500px' }}>
                {tipo !== null &&
                    <Consecuencias toast={toast} permss={permss} generic={generic} riesgo={riesgo} tipo={tipo} id={id} funcionalidades={funcionalidades} actualizarCatalogo={actualizarCatalogo} />}
            </Dialog>
        </>
    )
}
